export default __webpack_public_path__ + "media/GETTINGSTARTED.9377ff6d4149ca8f8f01f05f2d97e58b.mp4";